(function () {
  'use strict';

  if (window.__simCollectionInit) return;
  window.__simCollectionInit = true;

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-sim-filter-toggle]');
    if (toggle) {
      var section = toggle.closest('[data-sim-collection]');
      if (!section) return;
      var isOpen = section.classList.toggle('is-filters-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }

    if (!event.target.closest('.sim-filter')) {
      document.querySelectorAll('.sim-filter[open]').forEach(function (filter) {
        filter.removeAttribute('open');
      });
    }
  });

  document.addEventListener('toggle', function (event) {
    var current = event.target;
    if (!current.classList || !current.classList.contains('sim-filter') || !current.open) return;
    document.querySelectorAll('.sim-filter[open]').forEach(function (filter) {
      if (filter !== current) filter.removeAttribute('open');
    });
  }, true);

  document.addEventListener('change', function (event) {
    var sort = event.target.closest('[data-sim-sort]');
    if (sort && sort.form) sort.form.submit();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.sim-filter[open]').forEach(function (filter) {
      filter.removeAttribute('open');
    });
  });
})();
